import React from 'react';
import ReactDOM from 'react-dom';

import defaultPicture from '../images/contact-default.png';

export default class ContactMessage extends React.Component {
  constructor(props) {
    super(props);
    this.defaultPicture = defaultPicture;
    this.cancel = this.cancel.bind(this);
  }

  async componentDidMount() {
    this.audio = new Audio(await import('../sounds/busy.mp3'));
    this.audio.play();
  }

  componentWillUnmount() {
    this.audio.pause();
  }

  cancel() {
    ReactDOM.unmountComponentAtNode(document.getElementById('contactMessage'));
  }

  render() {
    const locale = global.dictionaries.calling;

    return (
      <div className="modal is-active">
        <div className="modal-background" />
        <div className="modal-content">
          <div className="contact-card">
            <img
              src={this.props.picture || this.defaultPicture}
              className="image"
              alt={this.props.name}
            />
            <p className="name">{this.props.name}</p>
            <hr />
            <p className="call-button">
              {locale[this.props.msgKey]}
            </p>
            <p className="cancel-button" onClick={this.cancel}>
              <span className="icon">
                <i className="fa fa-times" />
              </span>
              &nbsp;
              <span style={{ textTransform: 'capitalize' }}>{locale.cancel} ...</span>
            </p>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ContactMessage.js